import { Panel as BasePanel, type PanelProps } from 'baseui/accordion';

export const Panel = (props: PanelProps) => {
  return <BasePanel {...props}>{props.children}</BasePanel>;
};
